// @flow
import React from 'react'
import './styles.scss'
// https://reactjsexample.com/a-very-simple-echarts-wrapper-for-react/
import ReactEcharts from 'echarts-for-react'
import echarts from 'echarts'
import { Link } from '@ta-interaktiv/contentbricks'
import { monthNames } from 'components/locales/fr'
import { monthsAbbrevCap } from 'components/locales/fr'

// Rename variable for compatibility with DCH updates

export class AnnualComparison extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800,
      displayData: {},
      currentYear: -1,
      chartOptions: {},
      echartInstance: null,
      referencePeriod: '1991-2020' // 1961-1990
    }
    this.handleEvents = {
      mouseover: this.onChartHover,
      mouseout: this.onChartLeave
    }
  }

  onChartHover = params => {
    // console.log('+++++ params ++++')
    // console.log(params)

    // highlight the hovered series
    this.state.echartInstance.setOption(
      this.getOption(params.seriesIndex, this.state.referencePeriod)
    )
  }

  onChartLeave = params => {
    // console.log('+++++ params ++++')
    // console.log(params)

    // remove highlight
    if (params.color === this.props.lineColors.highlight) {
      this.state.echartInstance.setOption(
        this.getOption(-1, this.state.referencePeriod)
      )
    }
  }

  componentDidMount() {
    // prepare Data according to set lastMonth
    const rawDates = this.props.lastMonth.split('-')
    const lastYear = parseInt(rawDates[0])
    const lastMonth = parseInt(rawDates[1])
    const displayData = this.props.data

    const yearIndex = this.props.data.years.findIndex(x => x.year === lastYear)
    if (yearIndex >= 0) {
      const displayYears = this.props.data.years.slice(0, yearIndex + 1)
      const displayMonths = displayYears[yearIndex].months.slice(0, lastMonth)
      const displayDeltas = displayYears[yearIndex].reference_deltas[
        this.state.referencePeriod
      ].slice(0, lastMonth)
      displayData.years = displayYears
      displayData.years[yearIndex].months = displayMonths
    }

    this.setState({
      currentYear: displayData.years[displayData.years.length - 1].year
    })
    this.setState({ displayData: displayData }, () => {
      // console.log('this.state.displayData: ', this.state.displayData)

      // create options for echart
      this.setState(
        {
          chartOptions: this.getOption(-1, this.state.referencePeriod)
        },
        () => {
          this.setState({
            echartInstance: this.echarts_react.getEchartsInstance()
          })
        }
      )
    })
  }

  getAllYears(data, highlightIndex) {
    // console.log('data.years', data.years)
    // console.log('highlightIndex', highlightIndex)

    // get data for all years
    const allYears = data.years.map(
      function(currYear, index) {
        // console.log('currYear', currYear)
        // console.log('months', currYear.months)
        // console.log('currYear.year:', currYear.year)
        // console.log('currentYear:', this.state.currentYear)
        const currYearNum = parseInt(currYear.year)

        // retun data for all years
        return {
          name: currYear.year,
          type: 'line',
          data: currYear.months,
          color:
            index === highlightIndex
              ? this.props.lineColors.highlight
              : currYearNum === this.state.currentYear
              ? this.props.lineColors.current
              : this.props.lineColors.past,
          lineStyle: {
            width: 1,
            opacity:
              currYearNum === this.state.currentYear
                ? 1
                : index === highlightIndex
                ? 1
                : 0.05
          },
          z:
            currYearNum === this.state.currentYear
              ? 999
              : index === highlightIndex
              ? 9999
              : index,
          showSymbol: true,
          symbolSize: 6,
          itemStyle: {
            borderWidth: 2,
            opacity:
              currYearNum === this.state.currentYear || index === highlightIndex
                ? 1
                : 0.01
          },
          connectNulls: true,
          silent: false,
          animation: false
        }
      }.bind(this)
    )
    // console.log('data.years.length:', data.years.length)
    // console.log('highlightIndex:', highlightIndex)

    // data for reference period
    const refPeriod = {
      name: 'Ø ' + this.state.referencePeriod,
      type: 'line',
      color:
        highlightIndex >= data.years.length
          ? this.props.lineColors.highlight
          : this.props.lineColors.avg,
      lineStyle: {
        type: 'dashed',
        opacity: 1
      },
      z: 3,
      data: data.reference_periods[this.state.referencePeriod],
      showSymbol: false,
      connectNulls: true,
      silent: false
    }
    allYears.push(refPeriod)

    // add markline at 0
    const baseline = {
      name: 'baseline',
      type: 'line',
      color: '#FFFFFF',
      data: [0],
      silent: true,
      z: 2,
      markLine: {
        data: [
          {
            name: 'baseline',
            yAxis: 0
          }
        ],
        lineStyle: {
          type: 'solid'
        },
        label: {
          show: false
        },
        symbol: false,
        symbolSize: 0,
        animation: false
      }
    }
    allYears.push(baseline)

    // add month marks at the bottom
    const monthMarks = {
      name: 'monthMarks',
      type: 'line',
      color: '#8e8e8e',
      data: [0],
      silent: true,
      z: 1,
      markLine: {
        data: [
          {
            name: 'Jan',
            xAxis: 0
          },
          {
            name: 'Fév',
            xAxis: 1
          },
          {
            name: 'Mars',
            xAxis: 2
          },
          {
            name: 'Avr',
            xAxis: 3
          },
          {
            name: 'Mai',
            xAxis: 4
          },
          {
            name: 'Juin',
            xAxis: 5
          },
          {
            name: 'Juil',
            xAxis: 6
          },
          {
            name: 'Août',
            xAxis: 7
          },
          {
            name: 'Sept',
            xAxis: 8
          },
          {
            name: 'Oct',
            xAxis: 9
          },
          {
            name: 'Nov',
            xAxis: 10
          },
          {
            name: 'Déc',
            xAxis: 11
          }
        ],
        lineStyle: {
          type: 'dotted',
          opacity: 0.3
        },
        symbol: false,
        symbolSize: 0,
        animation: false
      }
    }
    allYears.push(monthMarks)

    // console.log('allYears')
    // console.log(allYears)
    return allYears
  }

  // Chart Options
  // https://ecomfe.github.io/echarts-doc/public/en/option.html#title
  getOption(higlightIndex, referencePeriod) {
    // console.log('*** getOption ***')
    // console.log('#### data ####', this.state.displayData)
    return {
      title: {
        text: '',
        subtext: ''
      },
      tooltip: {
        axisPointer: {
          snap: true,
          type: 'line'
        },
        trigger: 'item',
        textStyle: {
          color: '#333'
        },
        backgroundColor: '#f3f3f3',
        formatter: function(params, ticket, callback) {
          // console.log('#### params ####', params)
          // console.log('referencePeriod', referencePeriod)
          // console.log('#### data ####', this.state.displayData)
          const yearIndex = params.seriesIndex
          const monthIndex = params.dataIndex
          const currMonth = monthNames[monthIndex]
          const currYear = params.seriesName
          const currTemp = params.value
          const currDiff = this.state.displayData.years[yearIndex]
            .reference_deltas[this.state.referencePeriod][monthIndex]
          const outputDiff =
            currDiff < 0 ? currDiff.toFixed(1) : '+' + currDiff.toFixed(1)
          const title =
            '<div class="tip-title"><strong>' +
            currMonth +
            '</strong> | ' +
            currYear +
            '</div>'
          let tooltipContent = title + '<hr class="under" />'
          tooltipContent += '<div class="row">'
          tooltipContent += 'Température moyenne: '
          tooltipContent +=
            '<span class="weighted">' + currTemp + ' °C</span></div>'
          tooltipContent += '<div class="row">'
          tooltipContent += 'Écart:  '
          tooltipContent += '<span class="weighted">' + outputDiff
          ;(' °C</span><br />par rapport à la norme</div>')
          // callback(console.log('scrubbed to: ', params[0].dataIndex))
          return tooltipContent
        }.bind(this)
      },
      grid: [
        {
          top: this.state.isMobile ? '5%' : '5%',
          left: 4,
          right: 12,
          bottom: 10,
          containLabel: true
        }
      ],
      xAxis: {
        type: 'category',
        boundaryGap: false,
        z: 2,
        data: monthsAbbrevCap,
        axisLine: {
          lineStyle: {
            color: ['#fff']
          }
        },
        axisLabel: {
          textStyle: {
            color: '#fff'
          }
        },
        axisTick: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: ['#727272']
          },
          show: false
        },
        axisTick: {
          length: 10000,
          inside: true
        },
        axisLabel: {
          formatter: '{value} °C',
          textStyle: {
            color: '#fff'
          }
        }
      },
      series: this.getAllYears(this.state.displayData, higlightIndex)
    }
  }

  render() {
    // console.log('### DATA ###', this.state.displayData)
    // register theme object
    // theme object format example: https://github.com/apache/incubator-echarts/blob/master/theme/dark.js
    echarts.registerTheme('ta_theme', {
      backgroundColor: 'transparent',
      textStyle: {
        fontSize: '16',
        fontFamily:
          'TamediaChart,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif',
        color: '#333'
      },
      title: {
        textStyle: {
          color: '#333',
          fontSize: '22'
        },
        subtextStyle: {
          color: '#5f5f5f',
          fontSize: '18'
        }
      },
      legend: {
        left: 'left',
        orient: 'vertical',
        itemGap: 7,
        padding: [0, 0, 0, 10],
        itemWidth: 10,
        textStyle: {
          fontSize: '16'
        },
        show: false
      },
      label: {
        show: false
      },
      smooth: true
    })

    return (
      <div className='echart annual-comparison'>
        <h3>{this.props.title}</h3>
        <h5>{this.props.subtitle}</h5>
        <div className='key'>
          <div className='entry'>
            <img src={require('./images/current-year.svg')} />
            <div className='title'>
              <div className='label'>
                Température en {this.state.currentYear}
              </div>
            </div>
          </div>
          <div className='entry'>
            <img src={require('./images/reference-periode.svg')} />
            <div className='title'>
              <div className='label'>
                Température moyenne {this.state.referencePeriod}
              </div>
            </div>
          </div>
        </div>
        <ReactEcharts
          ref={e => {
            this.echarts_react = e
          }}
          onEvents={this.handleEvents}
          option={this.state.chartOptions}
          opts={{ renderer: 'canvas' }}
          notMerge
          lazyUpdate
          theme='ta_theme'
          style={{ height: this.state.isMobile ? '20em' : '23em' }}
        />
        <div className='source'>
         Source:{' '}
          {/* }
          <Link href='https://www.meteoschweiz.admin.ch/home/klima/schweizer-klima-im-detail/homogene-messreihen-ab-1864.html?region=Tabelle'>
            Meteoschweiz
          </Link>
        */}
          MétéoSuisse
        </div>
      </div>
    )
  }
}
